// Many screens call setLoading(true) and never reset it when a request fails,
// so loaders subscribe here and dismiss themselves on a network failure.
const listeners = new Set();

export const isOnline = () => navigator.onLine;

// A request that never got a response (offline, DNS failure, connection reset)
export const isNetworkError = (error) => !error?.response && (error?.code === "ERR_NETWORK" || error?.message === "Network Error");

export const onNetworkFailure = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const reportNetworkFailure = () => listeners.forEach((listener) => listener());

// Requests in flight when the connection drops can take a while to fail, so release loaders right away
window.addEventListener("offline", reportNetworkFailure);
